var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6Doticon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6.098,
    height: 10,
    viewBox: "0 0 6.098 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_29629",
    "data-name": "Path 29629",
    d: "M5.473,4.57a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,5.473,4.57Zm3.9,0a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,9.375,4.57Zm1.1,2.8a1.1,1.1,0,1,1-1.1-1.1A1.1,1.1,0,0,1,10.473,7.375Zm-5,1.1a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,5.473,8.473Zm5,2.8a1.1,1.1,0,1,1-1.1-1.1A1.1,1.1,0,0,1,10.473,11.277Zm-5,1.1a1.1,1.1,0,1,0-1.1-1.1A1.1,1.1,0,0,0,5.473,12.375Z",
    transform: "translate(-4.375 -2.375)",
    fill: "#203662",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Doticon);
export default __webpack_public_path__ + "static/media/6doticon.785a5b2f08263291186bf2639236fcd4.svg";
export { ForwardRef as ReactComponent };